import { createSelector } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { getPersistedItem, setPersistedItem } from '~/hooks/usePersistedStorage'

const name = 'collapsed'

const updateState = (state, key, id, value) => {
  if (!state[key]) {
    state[key] = {}
  }
  if (value) {
    if (!state[key]) {
      state[key] = {}
    }
    state[key][id] = true
  } else {
    delete state[key]?.[id]
  }
  setPersistedItem(name, state)
}

export const slice = createSlice({
  name,
  initialState: getPersistedItem(name) ?? {},
  reducers: {
    setCollapsed(state, { payload }) {
      if (!Array.isArray(payload)) {
        payload = [payload]
      }
      payload.forEach(({ key, id, collapsed }) => {
        updateState(state, key, id, collapsed)
      })
    },
    toggleCollapsed(state, { payload: { key, id } }) {
      updateState(state, key, id, !state[key]?.[id])
    },
  },
})

export const { setCollapsed, toggleCollapsed } = slice.actions

export const isCollapsed = createSelector(
  [
    (state) => state,
    (state, key) => key,
    (state, key, ids) => {
      if (ids && !Array.isArray(ids)) {
        ids = [ids]
      }
      return ids
    },
  ],
  (state, key, ids) => {
    return Array.isArray(ids)
      ? ids.every((id) => state[name][key]?.[id])
      : false
  }
)
